import { moment, objectToList } from "@/utils"
import AppService from "./app-service"

const path = "payables"

export default class PayableService extends AppService {

  constructor() {
    super({ path })
  }

  static get TYPES() {
    return {
      normal: { 
        id: "normal",
        icon: "file alternate outline icon", 
        label: '<i class="file alternate outline icon"></i> Normal',
        description: "Normal" 
      },
      credit: { 
        id: "credit",
        icon: "donate teal icon", 
        label: '<i class="donate teal icon"></i> Crédito',
        description: "Crédito",
      },
    }
  }

  static get STATUS() {
    return {
      paid: { 
        id: "paid",
        icon: "check circle green icon",
        label: '<i class="check circle green icon"></i> Baixado',
        description: "Baixado",              
      },
      expired: { 
        id: "expired",
        icon: "exclamation circle red icon", 
        label: '<i class="exclamation circle red icon"></i> Vencido',
        description: "Vencido", 
      },
      half_paid: { 
        id: "half_paid",
        icon: "check circle outline blue icon", 
        label: '<i class="check circle outline blue icon"></i> Baixado parcialmente',
        description: "Baixado parcialmente",
      },
      open: {
        id: "open",
        icon: "clock outline orange icon",
        label: '<i class="clock outline orange icon"></i> Em aberto',
        description: "Em aberto",
      },
    }
  }

  static getStatusList() {    
    return objectToList(PayableService.STATUS)
  }

  static getTypeList() {    
    return objectToList(PayableService.TYPES)
  }

  static getStatus(payable) {
    
    let status = ""
    const { realDueDate, value, balance } = payable
    const dueDate = moment(realDueDate).format("YYYYMMDD")
    const today = moment().format("YYYYMMDD")

    if (balance == 0) {

      status = "paid"

    } else if (dueDate < today) {

      status = "expired"

    } else if (balance > 0 && balance < value) {

      status = "half_paid"

    } else {

      status = "open"
    }

    return PayableService.STATUS[status]
  }

  filter(data) {
    return this.http.post(`${path}/filter`, data).then((payables) => {
      payables.forEach(PayableService.setPayableData)
      return payables
    })
  }

  onFindAll(payables) {
    payables.forEach(PayableService.setPayableData)
  }

  static setPayableData(payable) {
    payable.isExpired = PayableService.isExpired(payable)
    payable.statusData = PayableService.getStatus(payable)
    payable.typeData = PayableService.TYPES[payable.type]
  }

  static isExpired(payable)  {

    if (payable.balance == 0)
      return false
    
    const today = moment().format("YYYYMMDD")
    const realDueDate = moment(payable.realDueDate).format("YYYYMMDD")

    return (realDueDate < today)
  }

  settle(payableId, data) {

    if (!data.date)
      data.date = moment(data.date).format("YYYY-MM-DD")

    return this.http.post(`${path}/${payableId}/settles`, data)
  }

  deleteSettle(payableId, settleId) {
    return this.http.delete(`${path}/${payableId}/settles/${settleId}`)
  }

  getCredits(payableId) {
    return this.http.get(`${path}/${payableId}/credits`)
  }

  getCompensation(compensationId) {
    return this.http.get(`payable-compensations/${compensationId}`)
  }
}